import { SocketRooms } from '../sockets/socket.rooms';

/**
 * @deprecated Use SocketRooms.claim(jobId) from @jms/model instead.
 * The new room registry provides type-safe room definitions.
 */
export function getClaimRoom(tenant: string, jobId: string) {
    return SocketRooms.claim(jobId).key;
}